/** * 对Date的扩展，将 Date 转化为指定格式的String * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q)
    可以用 1-2 个占位符 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字) * eg: * (new
    Date()).pattern("yyyy-MM-dd hh:mm:ss.S")==> 2006-07-02 08:09:04.423
 * (new Date()).pattern("yyyy-MM-dd E HH:mm:ss") ==> 2009-03-10 二 20:09:04
 * (new Date()).pattern("yyyy-MM-dd EE hh:mm:ss") ==> 2009-03-10 周二 08:09:04
 * (new Date()).pattern("yyyy-MM-dd EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04
 * (new Date()).pattern("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
 */
Date.prototype.pattern = function(fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours() % 12 == 0 ? 12 : this.getHours() % 12, //小时
        "H+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468") : "") + week[this.getDay() + ""]);
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}
const common = {
    /**
     * 时间格式转换
     * @param {*} data
     */
    getTime3(date) {
        let d = new Date(date)
        let str = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
        return str
    },
    getTime4(date) {
        let d = new Date(date)
        let str = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes()
        return str
    },
    getTime5(date) {
        let d = new Date(date)
        let m = d.getMonth() + 1
        let str = d.getFullYear() + (m > 9 ? (m + '') : ('0' + m))
        return str
    },
    /**
     * 时间格式转换
     * @param {*} data
     */
    getTime(date) {
        let d = new Date(date)
        let str = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() // + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
        return str
    },
    getTime6(date) {
        let d = new Date(date)
        let m = d.getMonth() + 1
        let e = d.getDate()
        let str = d.getFullYear() + '/' + (m > 9 ? m : ('0' + m)) + '/' + (e > 9 ? e : ('0' + e)) // + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
        return Date.parse(new Date(str))
    },
    str2Stamp(date) {
        let datecur = new Date(date)
        let y = datecur.getFullYear()
        let m = datecur.getMonth() + 1
        let d = datecur.getDate()
        return {
            y: y,
            m: m,
            d: d
        }
    },
    getTime2(date) {
        let d = new Date(date)
        let str = d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日' // + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
        return str
    },
    // 保留两位小数
    toDecimal2(x) {
        var f = parseFloat(x)
        if (isNaN(f)) {
            return false
        }
        var f = Math.round(x * 100) / 100
        var s = f.toString()
        var rs = s.indexOf('.')
        if (rs < 0) {
            rs = s.length
            s += '.'
        }
        while (s.length <= rs + 2) {
            s += '0'
        }
        return s
    },
    // 保留一位小数
    toDecimal1(x) {
        var f = parseFloat(x)
        if (isNaN(f)) {
            return false
        }
        var f = Math.round(x * 10) / 10
        var s = f.toString()
        var rs = s.indexOf('.')
        if (rs < 0) {
            rs = s.length
            s += '.'
        }
        while (s.length <= rs + 1) {
            s += '0'
        }
        return s
    },
    // 获取3个月前详细日期
    getBeforeMonth() {
        var date = new Date();
        date.setMonth(date.getMonth() - 3);
        // console.log(date.toLocaleString());
        // alert(date.pattern('yyyy-MM-dd hh:mm:ss'));
        return date.pattern('yyyy-MM-dd hh:mm:ss')
    },
    payList: [{
        label: 1,
        value: '有价券支付'
    }, {
        label: 3,
        value: '银行卡'
    }, {
        label: 4,
        value: '会员卡'
    }, {
        label: 5,
        value: '现金支付'
    }, {
        label: 6,
        value: '微信支付'
    }, {
        label: 7,
        value: '支付宝'
    }, {
        label: 8,
        value: 'QQ钱包'
    }, {
        label: 9,
        value: '翼支付'
    }, {
        label: 10,
        value: '京东支付'
    }, {
        label: 11,
        value: '银联支付'
    }, {
        label: 12,
        value: '移动和包支付'
    }, {
        label: 80,
        value: '自定义'
    }],
    // 跳转页面方法
    toJump(event, path, query) {
        for (var key in query) {
            query[key] = encodeURIComponent(query[key])
        }
        event.$router.push({
            path: path,
            query: query
        });
    },
    // 获取路由中的参数
    getQuery(event) {
        let query = event.$route.query
        for (var key in query) {
            query[key] = decodeURIComponent(query[key])
        }
        return query
    }
}

export default common


// WEBPACK FOOTER //
// ./src/libs/common.js